<script setup>
import HelloWorld2 from './components/HelloWorld2.vue';
</script>

<template>
  <h1>Vue 3 入門</h1>
  <HelloWorld2 />
</template>
